exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content[data-v-603bb2fe] .ant-modal-header {\n  border-bottom: none;\n}\n.modal-content[data-v-603bb2fe] .ant-modal-body {\n  padding: 0 24px 10px;\n}\n.modal-content .coverUrl-item[data-v-603bb2fe] .ant-upload {\n  width: 200px;\n}\n", ""]);

// exports
